import baseRules from "./baseRules";
import rules2026 from "./rules2026";
// import rules2030 from "./rules2030";

export const taxRulesByYear = [
  { year: 2026, rules: rules2026 },
//   { year: 2030, rules: rules2030 }
];

export const taxLawByYear = {
  'revision_base': 2025,
  'revision_2026': 2026,
};

export function resolveTaxRules(year) {
  let rules = JSON.parse(JSON.stringify(baseRules));

  taxRulesByYear.forEach(rule => {
    if (year >= rule.year) {
      Object.keys(rule.rules).forEach(section => {
        rules[section] = {
          ...(rules[section] || {}),
          ...rule.rules[section]
        };
      });
    }
  });

  return rules;
}